<template>
  <div class="wrapper">
    <div class="main visual-2 abt-hospital hosp-profile">
      <Header :backRoute="'/hospital-settings'" />

      <div class="hospital-info">
        <div class="hospital-details">
          <div class="hospital-image">
            <img
              :src="hospitalImage"
              :alt="hospital.name || 'Hospital'"
              class="hospital-img"
              height="550"
            />
            <!-- <div class="rating">
              <span>
                ⭐ {{ roundedAverageRating(hospital) }} ({{
                  formattedTotalReviews(hospital)
                }}
                Reviews)
              </span>
            </div> -->
          </div>

          <div class="hospital-description">
            <div class="form-grid">
              <div class="form-column">
                <div class="form-row">
                  <div class="form-group">
                    <label>Hospital Name:</label>
                    <div class="input-group">
                      <i class="fa-solid fa-hospital"></i>
                      <input
                        v-model="hospital.name"
                        type="text"
                        placeholder="Enter Hospital Name"
                      />
                    </div>
                    <p v-if="errors.name" class="error">{{ errors.name }}</p>
                  </div>

                  <div class="form-group">
                    <label>Contact Number:</label>
                    <div class="input-group">
                      <i class="fa-solid fa-phone"></i>
                      <input
                        v-model="hospital.contactNumber"
                        type="text"
                        placeholder="Enter Contact Number"
                      />
                    </div>
                    <p v-if="errors.contactNumber" class="error">
                      {{ errors.contactNumber }}
                    </p>
                  </div>

                  <div class="form-group">
                    <label>Address:</label>
                    <div class="input-group">
                      <i class="fa-solid fa-location-dot"></i>
                      <input
                        v-model="hospital.address"
                        type="text"
                        placeholder="Enter Address"
                      />
                    </div>
                    <p v-if="errors.address" class="error">
                      {{ errors.address }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="sv-btn">
              <button class="add-new-button" @click="updateHospitalProfile">
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "../layout/Header.vue";
import { HospitalsService } from "@/services/hospitals.service";

export default {
  components: {
    FooterView,
    Header,
  },
  name: "HospitalProfile",
  data() {
    const currentUser = this.$store?.state?.user?.currentUser;
    return {
      hospital: { ...currentUser?.profile }, // shallow copy
      user: { ...currentUser }, // shallow copy
      errors: {},
    };
  },
  computed: {
    hospitalImage() {
      const storedHospitalId = localStorage.getItem("hospitalId");

      // ✅ Show special hospital image for this one hospital only
      if (storedHospitalId === "68d68a07d3f9b7819cd05e80" || this.hospital?.id === "68d68a07d3f9b7819cd05e80") {
        return require("@/assets/img/494204040_1434613714551416_3095586470864192143_n.jpg");
      }

      // Otherwise fallback to normal or default hospital image
      return this.hospital?.photo || require("@/assets/img/hospital-img.png");
    },
  },
  methods: {
    roundedAverageRating(data) {
      return data?.averageRating?.averageRating
        ? data.averageRating.averageRating.toFixed(1) // Rounds to 1 decimal place
        : "0.0";
    },
    formattedTotalReviews(data) {
      const reviews = data?.averageRating?.totalReviews || 0;
      return reviews >= 1000
        ? `${(reviews / 1000).toFixed(1)}K`
        : reviews.toString();
    },
    async updateHospitalProfile() {
      try {
        const payload = {
          name: this.hospital.name,
          contactNumber: this.hospital.contactNumber,
          address: this.hospital.address,
        };

        await HospitalsService.update(this.hospital.id, payload);

        // Show success toast
        this.$store.commit("toast/NEW", {
          type: "success",
          message: "Hospital profile updated successfully",
        });

        // Redirect after 800ms (toast visible)
        setTimeout(() => {
          window.location.href = "/hospital-settings";
        }, 800);
      } catch (error) {
        console.error("Error updating hospital profile", error);

        // Show error toast
        this.$store.commit("toast/NEW", {
          type: "error",
          message: "Failed to update hospital profile",
        });
      }
    },
  },
};
</script>

<style scoped>
.map-container {
  margin-top: 10px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.form-grid {
  display: flex;
  /* flex-wrap: wrap;
  gap: 20px; */
  /* justify-content: space-between; */
}

.form-column {
  flex: 1;
  /* display: flex;
  flex-wrap: wrap;
  gap: 20px; */
}

/* .form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  margin-bottom: 10px;
} */

.form-group {
  flex: 1;
  min-width: 250px; /* Ensures responsive layout */
  margin-bottom: 30px;
}

.form-group label {
  font-weight: 500;
  font-size: 18px;
}

.input-group {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-group input,
.input-group select {
  flex: 1;
  padding: 18px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 17px;
}
.fa-solid {
  font-size: 27px !important;
  background-color: #3c78f9;
  color: #fff;
  padding: 18px 12px;
  font-size: 18px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.input-group i {
  width: 58px;
  text-align: center;
}
.hospital-description {
  width: 60%;
}
.hosp-profile .hospital-details {
  display: flex;
  align-items: center;
  gap: 20px;
}
.sv-btn button {
  margin: 0;
  padding: 16px 40px;
}
.hosp-profile {
  justify-content: center;
  display: flex;
  padding: 0;
}
.hosp-profile .hospital-info {
  width: 100%;
}
.hosp-profile img.hospital-img {
  height: 520px;
}
</style>
